(function() {
  var componentRoot = document.querySelector('.jm-rc-brand-page[data-jm-rc-brand]');
  if (!componentRoot) return;
  if (componentRoot.getAttribute('data-jm-rc-brand-initialized') === 'true') return;

  // ===== Brand alias redirects (JS safety net) =====
  try {
    var bh = String(componentRoot.getAttribute('data-jm-brand-handle') || '').trim().toLowerCase();
    var BRAND_ALIASES = { "hpi": "hpi-racing", "axial": "axial-racing" };
    if (BRAND_ALIASES[bh]) {
      window.location.replace("/pages/rc-brand-" + BRAND_ALIASES[bh]);
      return;
    }
  } catch(e) {}

  var root = componentRoot.querySelector('[data-jm-brand-series-root]');
  if (!root) return;

  componentRoot.setAttribute('data-jm-rc-brand-initialized', 'true');

  var serverDirectoryAvailable = root.getAttribute('data-jm-server-directory') === 'true';
  var serverDirectoryHTML = serverDirectoryAvailable ? root.innerHTML : '';

  var searchEl = componentRoot.querySelector('[data-jm-brand-model-search]');
  var statusEl = componentRoot.querySelector('[data-jm-brand-filter-status]');
  var featuredModelsBlock = componentRoot.querySelector('[data-jm-brand-featured-models]');

  try {
    var brandDisplay = componentRoot.getAttribute('data-jm-brand-display') || '';
    var searchExampleOne = String(componentRoot.getAttribute('data-jm-search-example-one') || '').trim();
    var searchExampleTwo = String(componentRoot.getAttribute('data-jm-search-example-two') || '').trim();
    var debugOn = (window.location.search || '').indexOf('debug=1') !== -1;

    var searchLabelEl = componentRoot.querySelector('label[for="jm-brand-model-search"]');
    if (searchLabelEl) {
      searchLabelEl.textContent = '';

      var searchLabelAction = document.createElement('span');
      searchLabelAction.className = 'jm-rcbrand-search-label__action';
      searchLabelAction.textContent = 'Search RC Models for';

      var searchLabelBrand = document.createElement('span');
      searchLabelBrand.className = 'jm-rcbrand-search-label__brand';
      searchLabelBrand.textContent = brandDisplay;

      searchLabelEl.appendChild(searchLabelAction);
      searchLabelEl.appendChild(searchLabelBrand);
    }

    if (searchEl && window.matchMedia) {
      var searchPlaceholderMedia = window.matchMedia('(min-width: 375px)');
      var syncSearchPlaceholder = function() {
        searchEl.setAttribute(
          'placeholder',
          searchPlaceholderMedia.matches ? 'Search by model, series, or OEM' : 'Model, series, or OEM'
        );
      };

      syncSearchPlaceholder();
      if (searchPlaceholderMedia.addEventListener) {
        searchPlaceholderMedia.addEventListener('change', syncSearchPlaceholder);
      } else if (searchPlaceholderMedia.addListener) {
        searchPlaceholderMedia.addListener(syncSearchPlaceholder);
      }
    }

    function normalizeHandle(s) {
      s = String(s || '');
      try {
        if (s.indexOf('http') === 0) {
          var u = new URL(s);
          s = (u.pathname || '');
        }
      } catch(e) {}
      s = s.split('?')[0].split('#')[0];
      if (s.indexOf('/collections/') !== -1) s = s.split('/collections/').pop();
      s = s.replace(/^\/+/, '').split('/')[0].trim();
      s = s.replace(/^collections\//, '').trim();
      return s;
    }

    var featuredHandles = [];
    var featuredDataValid = true;
    var featuredNodes = componentRoot.querySelectorAll('[data-jm-brand-featured-model]');
    for (var featuredIndex=0; featuredIndex<featuredNodes.length; featuredIndex++) {
      var featuredNode = featuredNodes[featuredIndex];
      var featuredTitleNode = featuredNode.querySelector('[data-jm-brand-model-title]');
      var featuredUrl = String(featuredNode.getAttribute('href') || '').trim();
      var featuredTitle = featuredTitleNode ? String(featuredTitleNode.textContent || '').trim() : '';
      var featuredHandle = normalizeHandle(featuredUrl);

      if (!featuredTitle || !featuredUrl || !featuredHandle || featuredHandles.indexOf(featuredHandle) !== -1) {
        featuredDataValid = false;
        break;
      }

      featuredHandles.push(featuredHandle);
    }
    if (!featuredDataValid) return;

    function toHandle(s){
      return String(s || '')
        .toLowerCase()
        .replace(/&/g,'and')
        .replace(/[^a-z0-9]+/g,'-')
        .replace(/^-+|-+$/g,'')
        .replace(/-+/g,'-');
    }

    function esc(s){
      return String(s || '')
        .replace(/&/g,'&amp;')
        .replace(/</g,'&lt;')
        .replace(/>/g,'&gt;')
        .replace(/"/g,'&quot;')
        .replace(/'/g,'&#39;');
    }

    function searchExamplesGuidanceHTML(){
      if (!searchExampleOne) return 'Search by model or series.';
      if (!searchExampleTwo) return 'Example search: “' + esc(searchExampleOne) + '”.';
      return 'Example searches: “' + esc(searchExampleOne) + '” and “' + esc(searchExampleTwo) + '”.';
    }

    function escapeRegExp(s){
      return String(s || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    function normalizeForSearch(s){
      return String(s || '')
        .toLowerCase()
        .trim()
        .replace(/[_–—]/g, '-')
        .replace(/[^a-z0-9]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function expandSynonyms(q){
      q = normalizeForSearch(q);
      var alts = [q];

      function add(x){
        x = normalizeForSearch(x);
        if (x && alts.indexOf(x) === -1) alts.push(x);
      }

      add(q.replace(/\s+/g, ''));

      add(q.replace(/\bii\b/g, '2'));
      add(q.replace(/\biii\b/g, '3'));
      add(q.replace(/\b2\b/g, 'ii'));
      add(q.replace(/\b3\b/g, 'iii'));

      add(q.replace(/\b4x4\b/g, '4wd'));
      add(q.replace(/\b4wd\b/g, '4x4'));

      add(q.replace(/\b2wd\b/g, '2x4'));
      add(q.replace(/\b2x4\b/g, '2wd'));

      return alts;
    }

    function matchesQuery(titleOrSeries, query){
      var t = normalizeForSearch(titleOrSeries);
      var tCompact = t.replace(/\s+/g, '');

      var alts = expandSynonyms(query);
      for (var i=0; i<alts.length; i++){
        var a = normalizeForSearch(alts[i]);
        if (!a) continue;

        if (t.indexOf(a) !== -1) return true;

        var aCompact = a.replace(/\s+/g, '');
        if (aCompact && tCompact.indexOf(aCompact) !== -1) return true;
      }
      return false;
    }

    function prettyModelLabel(title){
      var t = String(title || '').trim();

      try {
        var bd = String(brandDisplay || '').trim();
        if (bd) {
          var tLow = t.toLowerCase();
          var bdLow = bd.toLowerCase();
          if (tLow.indexOf(bdLow + ' ') === 0) {
            t = t.slice(bd.length).trim();
          }
        }
      } catch(e) {}

      var max = 44;
      if (t.length > max) {
        t = t.slice(0, max);
        t = t.replace(/\s+\S*$/,'');
        t = t + '…';
      }
      return t;
    }

    function highlightTitleHTML(title, q){
      var raw = String(title || '');
      var query = String(q || '').trim();
      if (!query) return esc(raw);

      var hayLower = raw.toLowerCase();

      var candidates = [];
      function pushCand(x){
        x = String(x || '').trim();
        if (!x) return;
        var xl = x.toLowerCase();
        for (var i=0;i<candidates.length;i++){
          if (candidates[i] === xl) return;
        }
        candidates.push(xl);
      }

      pushCand(query);

      var qNorm = normalizeForSearch(query).replace(/\s+/g,'');
      pushCand(qNorm);

      if (qNorm) {
        pushCand(qNorm.replace(/([a-z])(\d)/g,'$1-$2'));
        pushCand(qNorm.replace(/([a-z])(\d)/g,'$1 $2'));
      }

      var alts = expandSynonyms(query) || [];
      for (var a=0; a<alts.length; a++) {
        var alt = String(alts[a] || '');
        if (!alt) continue;
        pushCand(alt);
        pushCand(alt.replace(/\s+/g,''));
        pushCand(alt.replace(/([a-z])(\d)/g,'$1-$2'));
        pushCand(alt.replace(/([a-z])(\d)/g,'$1 $2'));
      }

      for (var c=0; c<candidates.length; c++){
        var needle = candidates[c];
        var idx = hayLower.indexOf(needle);
        if (idx !== -1) {
          var before = raw.slice(0, idx);
          var hit = raw.slice(idx, idx + needle.length);
          var after = raw.slice(idx + needle.length);
          return esc(before) + '<span class="jm-hl">' + esc(hit) + '</span>' + esc(after);
        }
      }

      var compact = qNorm || normalizeForSearch(query).replace(/\s+/g,'');
      if (compact.length >= 2) {
        try {
          var parts = compact.split('').map(function(ch){ return escapeRegExp(ch); });
          var re = new RegExp(parts.join('[^a-z0-9]*'), 'i');
          var m = re.exec(raw);
          if (m && m.index != null && m[0]) {
            var b2 = raw.slice(0, m.index);
            var h2 = raw.slice(m.index, m.index + m[0].length);
            var a2 = raw.slice(m.index + m[0].length);
            return esc(b2) + '<span class="jm-hl">' + esc(h2) + '</span>' + esc(a2);
          }
        } catch(e) {}
      }

      return esc(raw);
    }

    function matchScore(title, q){
      var query = String(q || '').trim();
      if (!query) return 0;

      var tRaw = String(title || '');
      var t = normalizeForSearch(tRaw);
      var tCompact = t.replace(/\s+/g,'');

      var alts = expandSynonyms(query);
      var best = 0;

      for (var i=0; i<alts.length; i++){
        var a = normalizeForSearch(alts[i]);
        if (!a) continue;

        var aCompact = a.replace(/\s+/g,'');

        if (t === a) best = Math.max(best, 450);
        if (aCompact && tCompact === aCompact) best = Math.max(best, 440);

        if (t.indexOf(a) === 0) best = Math.max(best, 340);
        if (aCompact && tCompact.indexOf(aCompact) === 0) best = Math.max(best, 330);

        var pos = t.indexOf(a);
        if (pos !== -1) best = Math.max(best, 160 - Math.min(pos, 40));

        var pos2 = aCompact ? tCompact.indexOf(aCompact) : -1;
        if (pos2 !== -1) best = Math.max(best, 150 - Math.min(pos2, 40));
      }

      return best;
    }

    function setStatus(htmlOrText, isHtml){
      if (!statusEl) return;
      if (isHtml) statusEl.innerHTML = htmlOrText;
      else statusEl.textContent = htmlOrText;
    }

    function wireSeriesSelect(){
      if (componentRoot.getAttribute('data-jm-series-select-bound') === 'true') return;

      componentRoot.setAttribute('data-jm-series-select-bound', 'true');
      componentRoot.addEventListener('change', function(event){
        var sel = event.target;
        if (!sel || !sel.hasAttribute('data-jm-brand-series-select')) return;

        var v = String(sel.value || '');
        if (!v) return;
        try { window.location.hash = v.replace(/^#/, ''); } catch(e) {}
      });
    }

    function restoreServerDirectory(){
      if (!serverDirectoryAvailable) return false;
      root.innerHTML = serverDirectoryHTML;
      if (featuredModelsBlock) featuredModelsBlock.hidden = false;
      setStatus('', false);
      wireSeriesSelect();
      return true;
    }

    if (serverDirectoryAvailable) wireSeriesSelect();
    if (!serverDirectoryAvailable) return;

    var groups = {};
    var seenDirectoryHandles = {};
    var directoryDataValid = true;
    var directoryModelCount = 0;
    var seriesNodes = root.querySelectorAll('[data-jm-brand-series]');

    for (var seriesIndex=0; seriesIndex<seriesNodes.length; seriesIndex++) {
      var seriesNode = seriesNodes[seriesIndex];
      var seriesTitleNode = seriesNode.querySelector('[data-jm-brand-series-name]');
      var seriesName = seriesTitleNode ? String(seriesTitleNode.textContent || '').trim() : '';
      var modelNodes = seriesNode.querySelectorAll('[data-jm-brand-model]');

      if (!seriesName || groups[seriesName] || !modelNodes.length) {
        directoryDataValid = false;
        break;
      }

      groups[seriesName] = [];
      for (var modelIndex=0; modelIndex<modelNodes.length; modelIndex++) {
        var modelNode = modelNodes[modelIndex];
        var modelTitleNode = modelNode.querySelector('[data-jm-brand-model-title]');
        var modelTitle = modelTitleNode ? String(modelTitleNode.textContent || '').trim() : '';
        var modelUrl = String(modelNode.getAttribute('href') || '').trim();
        var modelHandle = normalizeHandle(modelUrl);

        if (!modelTitle || !modelUrl || !modelHandle || seenDirectoryHandles[modelHandle]) {
          directoryDataValid = false;
          break;
        }

        seenDirectoryHandles[modelHandle] = true;
        directoryModelCount++;
        groups[seriesName].push({
          model_name: modelTitle,
          url: modelUrl,
          collection_handle: modelHandle
        });
      }

      if (!directoryDataValid) break;
    }

    var seriesNames = Object.keys(groups).sort(function(a,b){ return String(a).localeCompare(String(b)); });
    var snapshotSeriesNode = componentRoot.querySelector('[data-jm-brand-meta-series-count]');
    var snapshotModelNode = componentRoot.querySelector('[data-jm-brand-meta-model-count]');
    var snapshotSeriesCount = snapshotSeriesNode ? parseInt(snapshotSeriesNode.textContent, 10) : NaN;
    var snapshotModelCount = snapshotModelNode ? parseInt(snapshotModelNode.textContent, 10) : NaN;

    if (!directoryDataValid || !seriesNames.length ||
        (isFinite(snapshotSeriesCount) && seriesNames.length > snapshotSeriesCount) ||
        (isFinite(snapshotModelCount) && directoryModelCount < snapshotModelCount)) {
      return;
    }

    var dbg = '';
    if (debugOn) {
      dbg += '<div style="opacity:.75;font-size:12px;margin:10px 0 14px 0;">';
      dbg += 'Debug: source = <b>server-rendered directory</b>';
      dbg += ' | series = <b>' + seriesNames.length + '</b>';
      dbg += ' | models = <b>' + directoryModelCount + '</b>';
      dbg += '</div>';
    }

    function itemTitle(it){
      return it && (it.model_name || it.model_display_name || it.model || it.title || it.name)
        ? (it.model_name || it.model_display_name || it.model || it.title || it.name)
        : 'Model';
    }

    function itemUrl(it){
      if (!it) return null;
      if (it.url) return String(it.url);

      var h = it.collection_handle || it.handle || it.collection || it.collectionHandle;
      if (!h) return null;

      if (typeof h === 'string' && (h.indexOf('/collections/') === 0 || h.indexOf('http') === 0 || h.indexOf('/') === 0)) return h;
      return '/collections/' + h;
    }

    function bestUrl(it){
      var u = itemUrl(it);
      return u ? String(u) : null;
    }

    function normQuery(q){
      return String(q || '').toLowerCase().replace(/\s+/g,' ').trim();
    }

    var allModels = [];
    for (var si0=0; si0<seriesNames.length; si0++) {
      var sn0 = seriesNames[si0];
      var lst0 = (groups[sn0] || []);
      for (var mi0=0; mi0<lst0.length; mi0++) {
        var it0 = lst0[mi0];
        var u0 = bestUrl(it0);
        if (!u0) continue;
        var h0 = normalizeHandle(u0);
        if (!h0) continue;
        allModels.push({
          title: itemTitle(it0),
          url: u0,
          handle: h0
        });
      }
    }
    function didYouMean(queryString, maxN){
      var q = String(queryString || '').trim();
      if (!q) return [];

      var alts = expandSynonyms(q);
      var qNorm = normalizeForSearch(q);
      var qCompact = qNorm.replace(/\s+/g,'');

      function tokenSet(s){
        var parts = normalizeForSearch(s).split(' ');
        var set = {};
        for (var i=0; i<parts.length; i++) if (parts[i]) set[parts[i]] = true;
        return set;
      }
      var qTokens = tokenSet(q);

      function overlapScore(title){
        var tNorm = normalizeForSearch(title);
        var best = 0;

        for (var i=0; i<alts.length; i++){
          var a = alts[i];
          if (!a) continue;
          if (tNorm === a) best = Math.max(best, 600);
          else if (tNorm.indexOf(a) === 0) best = Math.max(best, 520);
          else {
            var pos = tNorm.indexOf(a);
            if (pos !== -1) best = Math.max(best, 380 - Math.min(pos, 40));
          }
        }

        var tTokens = tokenSet(title);
        var inter = 0, qCount = 0;
        for (var k in qTokens){ if (qTokens.hasOwnProperty(k)) { qCount++; if (tTokens[k]) inter++; } }
        if (qCount) best = Math.max(best, inter * 60);

        var tCompact = tNorm.replace(/\s+/g,'');
        var cp = 0;
        var L = Math.min(qCompact.length, tCompact.length);
        for (var j=0; j<L; j++){
          if (qCompact.charAt(j) === tCompact.charAt(j)) cp++;
          else break;
        }
        if (cp) best = Math.max(best, cp * 12);

        return best;
      }

      var scored = [];
      var seen = {};
      for (var i=0; i<allModels.length; i++){
        var m = allModels[i];
        var h = String(m.handle || '');
        if (!h || seen[h]) continue;
        seen[h] = true;

        var s = overlapScore(m.title);
        if (s > 0) scored.push({ title: m.title, url: m.url, score: s });
      }

      scored.sort(function(a,b){
        if (b.score !== a.score) return b.score - a.score;
        return String(a.title).localeCompare(String(b.title));
      });

      return scored.slice(0, maxN || 5);
    }

    function render(queryString){
      var q = normQuery(queryString);
      if (featuredModelsBlock) featuredModelsBlock.hidden = !!q;

      if (!q && serverDirectoryAvailable) {
        restoreServerDirectory();
        return;
      }

      var html = dbg;

      var renderedHandles = {};

      var seriesKeep = {};
      var renderSeries = [];
      var totalModels = 0;

      for (var si=0; si<seriesNames.length; si++) {
        var series = seriesNames[si];
        var itemsList = (groups[series] || []).slice();
        itemsList.sort(function(a,b){ return String(itemTitle(a)).localeCompare(String(itemTitle(b))); });

        var keep = [];
        var seriesMatched = q && matchesQuery(series, q);

        for (var ii=0; ii<itemsList.length; ii++) {
          var it = itemsList[ii];
          var url = bestUrl(it);
          if (!url) continue;

          var h = normalizeHandle(url);
          if (!h) continue;

          if (renderedHandles[h]) continue;

          var title = itemTitle(it);

          if (q && !seriesMatched) {
            if (!matchesQuery(title, q)) continue;
          }

          var score = q ? matchScore(title, q) : 0;

          keep.push({
            title: title,
            title_html: q ? highlightTitleHTML(title, queryString) : esc(title),
            url: url,
            handle: h,
            score: score
          });

          renderedHandles[h] = true;
        }

        if (q) {
          keep.sort(function(a,b){
            if ((b.score || 0) !== (a.score || 0)) return (b.score || 0) - (a.score || 0);
            return String(a.title).localeCompare(String(b.title));
          });
        }

        if (keep.length) {
          seriesKeep[series] = keep;
          renderSeries.push(series);
          totalModels += keep.length;
        }
      }

      if (!q) {
        setStatus('', false);
      } else if (renderSeries.length) {
        setStatus('Showing ' + totalModels + ' matching models across ' + renderSeries.length + ' series.', false);
      } else {
        var sug = didYouMean(q, 5);
        var clearLink = ' <a class="jm-rcbrand-clear-search" href="#" data-jm-clear-search>Clear search</a>';

        if (sug.length) {
          var sHtml = 'No exact matches for <b>' + esc(queryString) + '</b>.' + clearLink;
          sHtml += '<div class="jm-rcbrand-didyoumean-label">Did you mean:</div>';
          sHtml += '<div class="jm-rcbrand-suggestions">';
          for (var si=0; si<sug.length; si++){
            sHtml += '<a class="jm-rcbrand-suggestion-link" href="' + esc(sug[si].url) + '">'
                  +  esc(prettyModelLabel(sug[si].title))
                  +  '</a>';
          }
          sHtml += '</div>';
          setStatus(sHtml, true);
        } else {
          setStatus('No models match <b>' + esc(queryString) + '</b>.' + clearLink, true);
        }
      }

      if (!renderSeries.length) {
        html += q
          ? '<p class="jm-compat-subhint">No models match <b>' + esc(queryString) + '</b>. ' + searchExamplesGuidanceHTML() + '</p>'
          : '<p class="jm-compat-subhint">No models found for this brand.</p>';
        root.innerHTML = html;
        attachClearHandler();
        return;
      }

      if (!q && renderSeries.length > 1) {
        html += '<nav class="jm-series-sticky" aria-label="Jump to series">';
        html += '<div class="jm-series-sticky-row">';
        for (var c=0; c<renderSeries.length; c++) {
          var sname2 = renderSeries[c];
          var sid = 'jm-series-' + toHandle(sname2);
          html += '<a class="jm-series-tab" href="#' + sid + '" title="' + esc(sname2) + '">'
               + esc(sname2) + '</a>';
        }
        html += '</div></nav>';

        html += '<div class="jm-series-select-wrap">';
        html += '<label class="jm-series-select-label" for="jm-series-select">Jump to series</label>';
        html += '<select id="jm-series-select" class="jm-series-select jm-compat-select" data-jm-brand-series-select>';
        html += '<option value="">Select a series…</option>';
        for (var d=0; d<renderSeries.length; d++) {
          var sname3 = renderSeries[d];
          var sid2 = 'jm-series-' + toHandle(sname3);
          html += '<option value="#' + sid2 + '">' + esc(sname3) + '</option>';
        }
        html += '</select></div>';

        html += '<section class="jm-series-index" aria-label="Series index">';
        html += '<h2>Series Index</h2>';
        html += '<div class="jm-series-index-grid">';
        for (var g=0; g<renderSeries.length; g++) {
          var sname4 = renderSeries[g];
          var sid3 = 'jm-series-' + toHandle(sname4);
          var count = (seriesKeep[sname4] || []).length;
          html += '<a class="jm-series-card" href="#' + sid3 + '">'
               +   '<div class="jm-series-card-title">' + esc(sname4) + '</div>'
               +   '<div class="jm-series-card-sub">' + count + ' model' + (count === 1 ? '' : 's') + '</div>'
               + '</a>';
        }
        html += '</div></section>';
      }

      for (var rs=0; rs<renderSeries.length; rs++) {
        var series2 = renderSeries[rs];
        var keepList = seriesKeep[series2] || [];
        if (!keepList.length) continue;

        var seriesId = 'jm-series-' + toHandle(series2);

        var prevSeries = (rs > 0) ? renderSeries[rs - 1] : null;
        var nextSeries = (rs < renderSeries.length - 1) ? renderSeries[rs + 1] : null;
        var prevId = prevSeries ? ('jm-series-' + toHandle(prevSeries)) : null;
        var nextId = nextSeries ? ('jm-series-' + toHandle(nextSeries)) : null;

        html += '<section id="' + seriesId + '" class="jm-brandhub-series">';
        html +=   '<div class="jm-brandhub-series-head">';
        html +=     '<h2 style="margin:0;">' + esc(series2) + '</h2>';
        html +=     '<div class="jm-brandhub-series-actions">';
        html +=       '<div class="jm-series-prevnext">';
        if (prevId) html += '<a class="jm-series-navlink" href="#' + prevId + '" title="Previous: ' + esc(prevSeries) + '" aria-label="Previous series: ' + esc(prevSeries) + '">← Prev</a>';
        if (nextId) html += '<a class="jm-series-navlink" href="#' + nextId + '" title="Next: ' + esc(nextSeries) + '" aria-label="Next series: ' + esc(nextSeries) + '">Next →</a>';
        html +=       '</div>';
        html +=       '<a class="jm-brandhub-backtotop" href="#jm-brand-top">Back to top ↑</a>';
        html +=     '</div>';
        html +=   '</div>';

        html +=   '<div class="jm-brandhub-grid">';
        for (var k=0; k<keepList.length; k++) {
          html += '<a class="jm-brandhub-card" href="' + keepList[k].url + '">'
               +    '<div class="jm-brandhub-card-title">' + (keepList[k].title_html || esc(keepList[k].title)) + '</div>'
               +    '<div class="jm-brandhub-card-sub">Open model collection → kits</div>'
               +  '</a>';
        }
        html +=   '</div>';
        html += '</section>';
      }

      root.innerHTML = html;
      wireSeriesSelect();
      attachClearHandler();
    }

    function attachClearHandler(){
      if (!statusEl) return;
      var a = statusEl.querySelector('[data-jm-clear-search]');
      if (!a) return;
      a.addEventListener('click', function(e){
        e.preventDefault();
        try {
          if (searchEl) searchEl.value = '';
          if (!restoreServerDirectory()) render('');
          if (searchEl) searchEl.focus();
        } catch(err) {}
      });
    }

    // Model search (debounced)
    if (searchEl) {
      var tmr = null;
      searchEl.addEventListener('input', function(){
        var val = String(searchEl.value || '');
        if (featuredModelsBlock) featuredModelsBlock.hidden = !!normQuery(val);
        clearTimeout(tmr);
        tmr = setTimeout(function(){
          if (!normQuery(val) && restoreServerDirectory()) return;
          render(val);
        }, 90);
      });
    }

    // ===== Quick filter chips (AUTO from this brand's model titles) =====
try {
  var chipRow = componentRoot.querySelector('[data-jm-brand-chip-row]');
  var chipKicker = componentRoot.querySelector('[data-jm-brand-chip-kicker]');

  function titleTokensForChips(title){
    var t = normalizeForSearch(title);
    if (!t) return [];

    // keep common “signals” + meaningful tokens
    var raw = t.split(' ');
    var out = [];
    for (var i=0; i<raw.length; i++){
      var w = raw[i];
      if (!w) continue;

      // ignore very short noise
      if (w.length <= 1) continue;

      // ignore brand name token(s)
      try {
        var bd = normalizeForSearch(brandDisplay);
        if (bd && bd.split(' ').indexOf(w) !== -1) continue;
      } catch(e) {}

      out.push(w);
    }
    return out;
  }

  function makeChip(label, q){
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'jm-rcbrand-chip';
    b.setAttribute('data-jm-q', q);
    b.textContent = label;
    b.addEventListener('click', function(){
      if (!searchEl) return;
      searchEl.value = q;
      try {
        var ev = new Event('input', { bubbles:true });
        searchEl.dispatchEvent(ev);
      } catch(e2) {
        render(q);
      }
      searchEl.focus();
    });
    return b;
  }

  function buildAutoChips(){
    if (!chipRow || !searchEl) return;

    var counts = {};
    var total = 0;

    for (var i=0; i<allModels.length; i++){
      var tt = allModels[i].title || '';
      var tokens = titleTokensForChips(tt);
      for (var j=0; j<tokens.length; j++){
        var tok = tokens[j];

        // focus on “buyer-intent” tokens only
        var keep =
          /^v\d+$/.test(tok) ||                 // v2 v3 v4...
          tok === 'rtr' || tok === 'kit' || tok === 'roller' ||
          tok === '2wd' || tok === '4wd' || tok === '4x4' ||
          tok === 'brushless' || tok === 'nitro' ||
          tok === 'buggy' || tok === 'truggy' || tok === 'truck' ||
          tok === 'crawler' || tok === 'touring' || tok === 'drift' || tok === 'f1' ||
          /^1\s*\/\s*\d+$/.test(tok) ||         // (rare after normalize) safeguard
          /^1\/\d+$/.test(tok);                 // 1/10 1/8 etc.

        // also allow common scale token formats that normalize into "1 10"
        // If your titles store scales like "1/10", normalizeForSearch becomes "1 10"
        if (!keep) {
          if (tok === '1' && (tokens[j+1] === '10' || tokens[j+1] === '8' || tokens[j+1] === '7' || tokens[j+1] === '5' || tokens[j+1] === '16' || tokens[j+1] === '18' || tokens[j+1] === '24' || tokens[j+1] === '36')) {
            keep = true;
            tok = '1/' + tokens[j+1];
          }
        }

        if (!keep) continue;


counts[tok] = (counts[tok] || 0) + 1;
total++;

      }
    }

    // Turn counts into sorted candidates
    var cand = Object.keys(counts).map(function(k){
      return { tok:k, n:counts[k] };
    }).sort(function(a,b){
      if (b.n !== a.n) return b.n - a.n;
      return String(a.tok).localeCompare(String(b.tok));
    });

    // Only show chips that actually occur often enough to be meaningful
    var minHits = 3;
    var maxChips = 8;

    chipRow.innerHTML = '';
    var shown = 0;

    for (var c=0; c<cand.length; c++){
      if (shown >= maxChips) break;
      if (cand[c].n < minHits) break;

      var t = cand[c].tok;
      var label = t;

      // prettify labels
      if (t === 'rtr') label = 'RTR';
      else if (t === 'kit') label = 'Kit';
      else if (t === 'roller') label = 'Roller';
      else if (t === '2wd') label = '2WD';
      else if (t === '4wd') label = '4WD';
      else if (t === '4x4') label = '4x4';
      else if (/^v\d+$/.test(t)) label = t.toUpperCase();
      else if (/^1\/\d+$/.test(t)) label = t;

      chipRow.appendChild(makeChip(label, t));
      shown++;
    }

    if (shown > 0) {
      chipRow.style.display = '';
      if (chipKicker) chipKicker.style.display = '';
    } else {
      chipRow.style.display = 'none';
      if (chipKicker) chipKicker.style.display = 'none';
    }
  }

  buildAutoChips();
} catch(e) {}


  } catch (e) {
    if (!serverDirectoryAvailable) {
      root.innerHTML = '<p><b>Brand page script error:</b> ' + (e && e.message ? e.message : e) + '</p>';
    }
  }
})();
